export function buildBlogPostingSchema({
  siteUrl,
  siteName,
  contentPage,
  pageUrl,
  locale = 'fr',
  ogImage = null,
}) {
  const imageUrl = ogImage || `${siteUrl}/og-image.png`;
  const datePublished = contentPage.published || contentPage.modified;
  const dateModified = contentPage.modified || contentPage.published;

  return {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: contentPage.title,
    description: contentPage.description,
    url: pageUrl,
    datePublished,
    dateModified,
    image: imageUrl,
    author: {
      '@type': 'Organization',
      name: siteName,
      url: siteUrl,
    },
    publisher: {
      '@type': 'Organization',
      name: siteName,
      logo: {
        '@type': 'ImageObject',
        url: `${siteUrl}/logo.png`,
      },
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': pageUrl,
    },
    inLanguage: locale === 'en' ? 'en-US' : 'fr-FR',
  };
}
